import React from "react";

interface SelfProps {
    active: boolean
}

export default class ToggleIcon extends React.Component<SelfProps> {
    getColor = () => {
        return this.props.active ? '#4D5E80' : '#9E9E9E';
    }
}